/*
 * イベント記事の下部の関連イベント(2026-10-18、2026-10-20に3つの欄を追加)
 * 上から順に、該当があるものだけ表示する(いずれも今日以降に開催するもの):
 *   1. このシリーズの開催予定(同じ series_slug、最大3件)
 *   2. この会場で開催予定のイベント(同じ venue_id。無ければ同じ会場名、最大5件)
 *   3. 〇〇県で近日開催の植物イベント(同じ都道府県を日付の近い順、最大5件)
 *   4. このイベントに近い植物イベント(スクロールに合わせて10件ずつ、最大50件)
 *      選び方(近い場所を優先し、上から順に足りるまで):
 *      同じテーマ(タグ)×同じ都道府県 → 同じ都道府県 → 同じテーマ×同じエリア(関東など) → 同じテーマ×全国 → 同じエリア
 * 1〜3で出したイベントは4に出さない。カードは記事へのリンク(<a href>)で、記事本体やGoogle向けの情報は変えない。
 * データは公開のイベント表(events)を読み取り専用で取得する(一覧ページ events-list.js と同じ取得方法)。
 */
(function () {
  var box = document.getElementById('rel-feed');
  if (!box) return;
  // Shopifyの article.handle は「media/topics0000」のようにブログ名付きで来るため、最後の部分だけ使う
  var SLUG = String(box.getAttribute('data-slug') || '').split('/').pop();
  var cfg = window.SUPABASE_CONFIG || {};
  var REST = cfg.restBase || 'https://laixgcjvowdszrtdpxlq.supabase.co/rest/v1';
  var KEY = cfg.key || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxhaXhnY2p2b3dkc3pydGRweGxxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU2NTM5MTIsImV4cCI6MjA2MTIyOTkxMn0.yAvMili-p_uQMHYlz-fpErgFqX243J5z1zI87VqO63M';
  var PAGE = 10, MAX = 50;
  // どのイベントにも付きやすく、関連の手がかりにならない大分類のタグ
  var GENERIC = ['_plants', '_flower', '_season', '_nature', '_environment', '_plant_event'];
  var BROAD = ['ALL', 'KANTO', 'KANSAI', 'CHUBU', 'TOHOKU', 'KYUSHU', 'HOKKAIDO', 'CHUGOKU', 'SHIKOKU', 'OKINAWA'];
  var BROAD_JA = {KANTO:'関東',KANSAI:'関西',CHUBU:'中部',TOHOKU:'東北',KYUSHU:'九州',HOKKAIDO:'北海道',CHUGOKU:'中国',SHIKOKU:'四国',OKINAWA:'沖縄'};
  var WD = ['日', '月', '火', '水', '木', '金', '土'];
  var PREF = {HOKKAIDO:'北海道',AOMORI:'青森県',IWATE:'岩手県',MIYAGI:'宮城県',AKITA:'秋田県',YAMAGATA:'山形県',FUKUSHIMA:'福島県',IBARAKI:'茨城県',TOCHIGI:'栃木県',GUNMA:'群馬県',SAITAMA:'埼玉県',CHIBA:'千葉県',TOKYO:'東京都',KANAGAWA:'神奈川県',NIIGATA:'新潟県',TOYAMA:'富山県',ISHIKAWA:'石川県',FUKUI:'福井県',YAMANASHI:'山梨県',NAGANO:'長野県',GIFU:'岐阜県',SHIZUOKA:'静岡県',AICHI:'愛知県',MIE:'三重県',SHIGA:'滋賀県',KYOTO:'京都府',OSAKA:'大阪府',HYOGO:'兵庫県',NARA:'奈良県',WAKAYAMA:'和歌山県',TOTTORI:'鳥取県',SHIMANE:'島根県',OKAYAMA:'岡山県',HIROSHIMA:'広島県',YAMAGUCHI:'山口県',TOKUSHIMA:'徳島県',KAGAWA:'香川県',EHIME:'愛媛県',KOCHI:'高知県',FUKUOKA:'福岡県',SAGA:'佐賀県',NAGASAKI:'長崎県',KUMAMOTO:'熊本県',OITA:'大分県',MIYAZAKI:'宮崎県',KAGOSHIMA:'鹿児島県',OKINAWA:'沖縄県'};

  var list = box.querySelector('.rel-list');
  var sentinel = document.getElementById('rel-sentinel');
  if (!sentinel) return;
  var queue = [], seen = {}, shown = 0, loading = false, stageIdx = 0, stages = [];
  seen[SLUG] = true;

  function today() {
    var d = new Date(Date.now() + 9 * 3600 * 1000);
    return d.toISOString().slice(0, 10);
  }
  function api(q) {
    return fetch(REST + '/events?' + q, { headers: { apikey: KEY, Authorization: 'Bearer ' + KEY } })
      .then(function (r) { return r.ok ? r.json() : []; }).catch(function () { return []; });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function fmt(d, withYear) {
    var p = d.split('-'); var w = WD[new Date(d + 'T00:00:00Z').getUTCDay()];
    return (withYear ? p[0] + '年' : '') + Number(p[1]) + '月' + Number(p[2]) + '日（' + w + '）';
  }
  function period(e) {
    var s = e.start_date || e.event_date, en = e.end_date || '';
    if (!s) return '';
    if (!en || en === s) return fmt(s, true);
    return fmt(s, true) + '〜' + fmt(en, s.slice(0, 4) !== en.slice(0, 4));
  }
  function prefOf(e) {
    var r = e.regions || [];
    for (var i = 0; i < r.length; i++) { if (PREF[r[i]]) return PREF[r[i]]; }
    return '';
  }
  function imgOf(e) {
    var useDb = (e.source === 'user_submission' || e.is_workshop) && e.image_url;
    var base = useDb ? e.image_url : 'https://cdn.shopify.com/s/files/1/0658/5332/5495/files/' + e.slug + '.png';
    return base.indexOf('cdn.shopify.com') >= 0 ? base + (base.indexOf('?') >= 0 ? '&' : '?') + 'width=300' : base;
  }
  // 日ごとの行をイベント単位にまとめる(最初に出てきた行=一番近い開催日)
  function addRows(rows) {
    rows.forEach(function (e) {
      if (!e.slug || seen[e.slug]) return;
      seen[e.slug] = true;
      queue.push(e);
    });
  }
  function card(e) {
    var name = (e.event_title || '').trim() || e.title || '';
    var pref = prefOf(e);
    var a = document.createElement('a');
    a.className = 'rel-card';
    a.href = '/blogs/media/' + encodeURIComponent(e.slug);
    a.innerHTML =
      '<img class="rel-img" src="' + esc(imgOf(e)) + '" alt="' + esc(name) + '" width="300" height="300" loading="lazy" decoding="async" onerror="this.style.visibility=\'hidden\'">' +
      '<span class="rel-body"><span class="rel-title">' + esc(name) + '</span>' +
      '<span class="rel-meta">📅 ' + esc(period(e)) + '</span>' +
      (e.venue ? '<span class="rel-meta">📍 ' + esc(e.venue) + (pref ? '（' + esc(pref) + '）' : '') + '</span>' : (pref ? '<span class="rel-meta">🗾 ' + esc(pref) + '</span>' : '')) +
      '</span>';
    return a;
  }
  function render(n) {
    var added = 0;
    while (queue.length && added < n && shown < MAX) {
      list.appendChild(card(queue.shift())); added++; shown++;
    }
    if (shown > 0) box.hidden = false;
    return added;
  }
  // 次の段階の候補を取得して、表示待ちに足す
  function fetchNextStage() {
    if (stageIdx >= stages.length) return Promise.resolve(false);
    var q = stages[stageIdx++];
    return api(q).then(function (rows) { addRows(rows || []); return true; });
  }
  function loadMore() {
    if (loading || shown >= MAX) return;
    loading = true;
    (function fill() {
      if (queue.length >= PAGE || stageIdx >= stages.length) {
        render(PAGE);
        loading = false;
        if (shown >= MAX || (!queue.length && stageIdx >= stages.length)) { if (io) io.disconnect(); sentinel.hidden = true; return; }
        // 画面が大きく、追加後も目印が見えたままだと「新しく見えた」合図が出ないため、位置を確かめて続けて読み込む
        requestAnimationFrame(function () {
          if (sentinel.getBoundingClientRect().top < window.innerHeight + 600) loadMore();
        });
        return;
      }
      fetchNextStage().then(fill);
    })();
  }

  // 上の3つの欄(シリーズ・会場・都道府県)。該当が無ければ欄ごと出さない
  function fillSection(id, q, n, heading, more) {
    var sec = document.getElementById(id);
    if (!sec || !q) return Promise.resolve();
    return api(q).then(function (rows) {
      var picked = [];
      (rows || []).forEach(function (e) {
        if (picked.length >= n || !e.slug || seen[e.slug]) return;
        seen[e.slug] = true; picked.push(e);
      });
      if (!picked.length) return;
      if (heading) sec.querySelector('.ev-dn-heading').textContent = heading;
      var l = sec.querySelector('.rel-list');
      picked.forEach(function (e) { l.appendChild(card(e)); });
      if (more) {
        var a = document.createElement('a');
        a.className = 'ev-dn-more-link'; a.href = more.href; a.textContent = more.text;
        sec.appendChild(a);
      }
      sec.hidden = false;
    });
  }

  var io = null;
  api('slug=eq.' + encodeURIComponent(SLUG) + '&select=tags_en,regions,series_slug,venue_id,venue&limit=1').then(function (rows) {
    var cur = rows && rows[0];
    if (!cur) return;
    var tags = (cur.tags_en || []).filter(function (t) { return GENERIC.indexOf(t) < 0; });
    var regions = cur.regions || [];
    var pref = '', broad = '';
    regions.forEach(function (r) { if (PREF[r] && r !== 'HOKKAIDO' && r !== 'OKINAWA') pref = pref || r; else if (BROAD.indexOf(r) > 0) broad = broad || r; });
    if (!pref && (regions.indexOf('HOKKAIDO') >= 0)) pref = 'HOKKAIDO';
    if (!pref && (regions.indexOf('OKINAWA') >= 0)) pref = 'OKINAWA';
    var base = 'select=slug,title,event_title,event_date,start_date,end_date,venue,regions,image_url,source,is_workshop'
      + '&status=in.(open,full)&event_date=gte.' + today() + '&slug=neq.' + encodeURIComponent(SLUG) + '&order=event_date.asc&limit=300';
    var tagQ = tags.length ? '&tags_en=ov.{' + tags.map(encodeURIComponent).join(',') + '}' : '';
    // 近い場所を優先: 同じテーマ×都道府県 → 同じ都道府県 → 同じテーマ×エリア → 同じテーマ×全国 → 同じエリア
    if (tagQ && pref) stages.push(base + tagQ + '&regions=cs.{' + pref + '}');
    if (pref) stages.push(base + '&regions=cs.{' + pref + '}');
    if (tagQ && broad) stages.push(base + tagQ + '&regions=cs.{' + broad + '}');
    if (tagQ) stages.push(base + tagQ);
    if (broad) stages.push(base + '&regions=cs.{' + broad + '}');

    var venueName = String(cur.venue || '').trim();
    var venueQ = cur.venue_id ? base + '&venue_id=eq.' + encodeURIComponent(cur.venue_id)
      : (venueName ? base + '&venue=eq.' + encodeURIComponent(venueName) : '');
    var areaCode = pref || broad;
    var areaJa = pref ? PREF[pref] : (BROAD_JA[broad] || '');
    var short = venueName.length > 24 ? venueName.slice(0, 24) + '…' : venueName;
    // 順番に埋める(先に出したものは後の欄・下の続き読み込みに出さない)
    fillSection('rel-series', cur.series_slug ? base + '&series_slug=eq.' + encodeURIComponent(cur.series_slug) : '', 3, '')
      .then(function () { return fillSection('rel-venue', venueQ, 5, short ? short + 'で開催予定のイベント' : ''); })
      .then(function () {
        return fillSection('rel-area', areaCode ? base + '&regions=cs.{' + areaCode + '}' : '', 5,
          areaJa ? areaJa + 'で近日開催の植物イベント' : '',
          areaJa ? { href: '/blogs/media/event-' + areaCode.toLowerCase() + '-list', text: areaJa + 'の植物イベント一覧をもっと見る →' } : null);
      })
      .then(function () {
        if (!stages.length) return;
        // 画面の下のほうまで読み進めたら次を読み込む
        if ('IntersectionObserver' in window) {
          io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) loadMore(); }, { rootMargin: '600px 0px' });
          io.observe(sentinel);
        } else {
          loadMore();
        }
      });
  });
})();
